import each from 'lodash/each'

export default class GlobalNavi {
  constructor () {
    this.$triggers = document.getElementsByClassName('js-global-nav-trigger')
    this.$target = document.getElementById('js-global-nav-target')
    this.$targetInner = document.getElementById('js-global-nav-target-inner')
    this.$back = document.getElementById('js-global-nav-back')
    this.mediaQuery = window.matchMedia('only screen and (min-width: 1281px)')
    this.isOpen = false

    this.handleEvents()
  }

  handleEvents () {
    each(this.$triggers, el => {
      el.addEventListener('click', this.toggle.bind(this))
    })
    this.mediaQuery.addListener(this.hide.bind(this))
    this.$back.addEventListener('click', this.hide.bind(this))
  }

  toggle () {
    (!this.isOpen) ? this.show() : this.hide()
  }

  show () {
    this.$target.classList.add('is-active')
    this.$back.classList.add('is-active')
    each(this.$triggers, el => {
      el.classList.add('is-active')
    })

    this.isOpen = true
  }

  hide () {
    const transitionHandler = () => {
      this.$targetInner.scrollTop = 0
      this.$target.removeEventListener('transitionend', transitionHandler)
    }

    this.$target.addEventListener('transitionend', transitionHandler)
    this.$target.classList.remove('is-active')
    this.$back.classList.remove('is-active')
    each(this.$triggers, el => {
      el.classList.remove('is-active')
    })

    this.isOpen = false
  }
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/GlobalNavi.js